/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Already_Have_AccountInputs */

const en_common_sign_already_have_account = /** @type {(inputs: Common_Sign_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

const zh_common_sign_already_have_account = /** @type {(inputs: Common_Sign_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已有账号？`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Common_Sign_Already_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_already_have_account = /** @type {((inputs?: Common_Sign_Already_Have_AccountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Already_Have_AccountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_already_have_account(inputs)
	return zh_common_sign_already_have_account(inputs)
});
export { common_sign_already_have_account as "common.sign.already_have_account" }